import RiskDataGrid from './RiskDataGrid';
export { RiskDataGrid };
export default RiskDataGrid;
